import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from '../../../../app-configuration';
import { SmartReportTemplateModel } from './model/smart-report-template.model';

@Injectable()
export class SmartReportTemplateRestService {
  private readonly controllerUrl: string = this.appConfiguration.serverApiUrl + '/secured/smart-reports/';

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  create(payload: { smartReportId: number; smartReportTemplate: SmartReportTemplateModel }): Observable<any> {
    return this.httpClient.post<any>(this.controllerUrl + `${payload.smartReportId}/templates`, payload.smartReportTemplate);
  }

  update(payload: {
    smartReportTemplateId: number;
    template: SmartReportTemplateModel
  }): Observable<SmartReportTemplateModel> {
    return this.httpClient.put<SmartReportTemplateModel>(this.controllerUrl + `${payload.smartReportTemplateId}/templates`, payload.template);
  }

  delete(payload: { smartReportTemplateId: number }): Observable<void> {
    return this.httpClient.delete<any>(this.controllerUrl + `${payload.smartReportTemplateId}/templates`);
  }

  setTemplateAsDefault(payload: {templateId: number}): Observable<any> {
    return this.httpClient.post(this.controllerUrl + `${payload.templateId}/set-default-template`, {});
  }

  setTemplateAsDefaultForShared(payload: {templateId: number}): Observable<any> {
    return this.httpClient.post(this.controllerUrl + `${payload.templateId}/set-default-template-for-shared`, {});
  }

  getAllSmartReportTemplates(payload: {smartReportId: number}): Observable<SmartReportTemplateModel[]> {
    return this.httpClient.get<SmartReportTemplateModel[]>(this.controllerUrl + `${payload.smartReportId}/templates`);
  }
}
